import React from "react";

const FormGroup = ({ children,className }) => {
  return <div className={className}>{children}</div>;
};

export default FormGroup;
